import { render } from "./homeCarousel.vue?vue&type=template&id=cba931fe&scoped=true"
import script from "./homeCarousel.vue?vue&type=script&lang=js"
export * from "./homeCarousel.vue?vue&type=script&lang=js"

import "./homeCarousel.vue?vue&type=style&index=0&id=cba931fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba931fe"]])

export default __exports__